import { forwardRef } from 'react';
import useSummaryFunction from './useSummaryFunction';

export type SummaryFunctionHandle = {
  onClickSaveReport: () => Promise<void>;
  isChangedData: () => boolean;
  resetData: () => void;
};

export type SummaryFunctionProps = {
  studyId?: string;
  profileId?: string;
  isNotEdit?: boolean;
  // dead prop: index.tsx passes this but SummaryFunction never reads it.
};

/**
 * Headless controller for the Beats tab that owns the whole save pipeline and the tab's reset. Exposes onClickSaveReport, isChangedData and resetData through the forwarded ref via useSummaryFunction.
 *
 * @returns Null, since nothing is rendered and the save and reset handlers are reachable only through the ref.
 */
const SummaryFunction = forwardRef<SummaryFunctionHandle, SummaryFunctionProps>(
  ({ studyId, profileId, isNotEdit }, ref) => {
    useSummaryFunction({ studyId, profileId, isNotEdit }, ref);
    return null;
  },
);

export default SummaryFunction;
